import { useBeaker } from '@immutabl3/alchemy';

// it is possible for all beakers to be visible at the same time
// when jumping between chapters or simply toggling from one to the other
//
// this gets to be a big issue when multiple cameras are attempting to
// be default and when three.js animations are trying to run without
// target objects in the scene (creating desycns)
//
// mitigate this by only allowing one beaker to be visible at a time

export default function useActiveChapter() {
  const visible1 = useBeaker('chapter1', 'visible');
  const visible2 = useBeaker('chapter2', 'visible');
  const visible3 = useBeaker('chapter3', 'visible');

  if (visible1) return 'chapter1';
  if (visible2) return 'chapter2';
  if (visible3) return 'chapter3';
  return '';
};